/**
 * DisplayMode - View component for displaying a move in read-only mode
 * Pure presentation component with no business logic
 */

import React from 'react';

export default function DisplayMode({ moveObj }) {
  return (
    <div style={styles.displayContainer}>
      <div>{moveObj.text}</div>
    </div>
  );
}

const styles = {
  displayContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 4
  }
};
